import { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import {
  StyledModal,
  StyledModalHeader,
  MainButton,
} from '../../form/FormElements';
import Form from 'antd/es/form/Form';
import FormButtonsContainer from '../../../antd/form/FormButtonsContainer/FormButtonsContainer';
import { t } from '../../../../i18n';
import TextArea from 'antd/es/input/TextArea';
import { StyledLabel } from '../../form/FormElements';
import { useSendFeedbackMailMutation } from '../../../../redux/services/mail';
import { useToastMessages } from '../../../../hooks/useToastMessages';
import { required } from '../../../antd/form/FormValidation';
const FeedbackModal = ({ isOpen, setIsOpen }) => {
  const [form] = Form.useForm();
  const [sendFeedbackMail, { isSuccess: sendSuccess }] =
    useSendFeedbackMailMutation();

  const { successMessage } = useToastMessages();

  const textAreaRef = useRef(null);
  const handleFinish = (values) => {
    const currentUrl = window.location.href;
    sendFeedbackMail({
      content: values.feedback,
      url: currentUrl,
    });
    setIsOpen(false);
    form.resetFields();
  };

  useEffect(() => {
    if (sendSuccess) {
      successMessage({
        message: 'Spätná väzba bola úspešne odoslaná',
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sendSuccess]);

  useEffect(() => {
    if (isOpen) {
      setTimeout(() => {
        textAreaRef.current?.focus();
      }, 0);
    }
  }, [isOpen]);

  return (
    <StyledModal
      open={isOpen}
      size="md"
      onCancel={() => setIsOpen(false)}
      footer={null}
    >
      <StyledModalHeader>{t('Spätná väzba')}</StyledModalHeader>
      <div style={{ padding: '0px 10px 0px 10px' }}>
        <Form form={form} onFinish={handleFinish}>
          <StyledLabel>
            {t('Nahlásenie chyby alebo námet na zlepšenie')}
          </StyledLabel>

          <Form.Item
            name="feedback" // Field name to match with the form data
            rules={[{ required: true, message: required(t).message }]}
          >
            <TextArea
              ref={textAreaRef}
              style={{ height: 180, resize: 'none', marginBottom: 10 }}
            />
          </Form.Item>
          <FormButtonsContainer>
            <MainButton onClick={() => setIsOpen(false)}>
              {t('Zrušiť')}
            </MainButton>
            <MainButton htmlType="submit">{t('Poslať')}</MainButton>
          </FormButtonsContainer>
        </Form>
      </div>
    </StyledModal>
  );
};

FeedbackModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  setIsOpen: PropTypes.func.isRequired,
};

export default FeedbackModal;
